<script>
export default {
  name: "floatingFrameBg",
  data() {
    return {};
  },
  props: ["showFloatingBg"],
  mounted() {

    const clientWidth = window.screen.width;
    const cleintHeight = window.screen.height;
    this.$nextTick(function() {
      const frameDom = document.querySelector(".floating-frame");

      frameDom.style.width = clientWidth + "px";
   
      frameDom.style.height = cleintHeight + "px";
    });
  },
  methods: {
    //调用父组件事件
    hiddenFloating() {
      this.$emit("func");
    }
  },
  render() {
   
    return (
      <div style={{ display: this.showFloatingBg ? 'block' : 'none' }} class="floating-frame" onClick={this.hiddenFloating}>
        
      </div>

      // {this.$slots.default}
    );
  }
};
</script>
<style lang='scss'>
.floating-frame {
  // width:100%;
  // height:100%;
//   background: black;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10001;
  display: none;
}
</style>


